export var SearchResult;
(function (SearchResult) {
    SearchResult[SearchResult["Equal"] = 0] = "Equal";
    SearchResult[SearchResult["Greater"] = 1] = "Greater";
    SearchResult[SearchResult["Less"] = 2] = "Less";
})(SearchResult || (SearchResult = {}));
export function binarySearch(arr, test) {
    let start = 0;
    let end = arr.length - 1;
    // Iterate while start not meets end 
    while (start <= end) {
        // Find the mid index 
        let mid = Math.floor((start + end) / 2);
        const result = test(arr[mid]);
        // If element is present at mid, return True 
        if (result === SearchResult.Equal)
            return arr[mid];
        // Else look in left or right half accordingly 
        else if (result === SearchResult.Less)
            start = mid + 1;
        else
            end = mid - 1;
    }
    throw new Error("Expected element ");
}
export function compareFn(...fns) {
    return (a, b) => {
        for (let fn of fns) {
            const res = fn(a, b);
            if (res > 0)
                return 1;
            if (res < 0)
                return -1;
        }
        return 0;
    };
}
export function compareFnProps(...props) {
    return compareFn(...props.map((prop) => (a, b) => b[prop] - a[prop]));
}
